export default {
    routerName: '个人中心',
    user: {
        icon: 'アイコン',
        deptName: '部門名',
        name: '氏名',
        loginName: 'アカウント',
        email: 'メール',
        pwd: 'パスワード',
        password: '現在のパスワード',
        newPassword: '新しいパスワード',
        newPasswordConfirm: '新しいパスワード確認',
        mobile: '電話番号',
        type: 'タイプ',
        systemUser: 'システムユーザー',
        normalUser: '普通ユーザー',
        members: '会員ユーザー',
        sex: '性别',
        status: '状態',
        remark: '備考',
        male: '男性',
        female: '女性',
        open: '有効',
        close: '無効',
        postName: '職位',
        roleName: 'ロール',
    },
    base: {
        info: '基本情報',
    },
};
